import { useAlertUiTranslation } from '../../../../../../ui/hooks';
import { showCustomDialog } from '@juvare/common-web-ui/DialogHelper';
import { themeColors } from '@juvare/common-web-ui/JuvareTheme';
import { Box, Button, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import React from 'react';
export function showGroupNamesDialog({ recipientName, groupNames }) {
    return showCustomDialog({
        content: (close, ariaTitleId, ariaContentId) => (React.createElement(GroupNamesDialogContent, { recipientName: recipientName, groups: groupNames, close: () => close(undefined), ariaTitleId: ariaTitleId, ariaContentId: ariaContentId })),
    });
}
const GroupNamesDialogContent = (props) => {
    const { t } = useAlertUiTranslation();
    return (React.createElement(Box, null,
        React.createElement(DialogTitle, { id: props.ariaTitleId }, t(`pages.tables.details.respondersTable.associationsOf`, { name: props.recipientName })),
        React.createElement(DialogContent, { id: props.ariaContentId }, props.groups.map((group, index, array) => {
            return (React.createElement(Box, { key: index, sx: { p: 2, mb: index < array.length - 1 ? 1 : 0, backgroundColor: themeColors.surface.secondary } },
                React.createElement(Typography, { variant: 'subtitle2' }, group)));
        })),
        React.createElement(DialogActions, null,
            React.createElement(Button, { variant: 'text', onClick: () => props.close() }, t('common.close')))));
};
